import { createContext, useContext, useEffect, useState } from "react";
import { api, saveToken, clearToken, getToken, formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // user state: undefined = checking, null = logged out, object = logged in
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const t = getToken();
    if (!t) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        clearToken();
        setUser(null);
      });
  }, []);

  async function login(email, password) {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.access_token) saveToken(data.access_token);
      setUser(data);
      return { ok: true };
    } catch (err) {
      return { ok: false, error: formatApiError(err) };
    }
  }

  async function logout() {
    try {
      await api.post("/auth/logout");
    } catch (_) {}
    clearToken();
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
